<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1050px">
      <v-form enctype="multipart/form-data" ref="form" v-model="valid_form">
        <v-card class="rounded-lg elevation-4 overflow-hidden">
          <!-- Toolbar Header -->
          <v-toolbar height="60" color="secondary" dark flat class="px-3">
            <v-icon left>mdi-truck-remove-outline</v-icon>
            <span class="text-h6 font-weight-medium">
              Registro de neumático directo a SCRAP
            </span>
            <v-chip
              v-if="Item && Item.num_serie"
              color="white"
              text-color="secondary"
              class="font-weight-bold ml-3 px-3 elevation-1"
              style="font-size: 1.05rem; height: 36px"
            >
              <v-icon left size="20" color="secondary">mdi-barcode-scan</v-icon>
              Serie: {{ Item.num_serie }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="cerrarDialogo()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-5">
            <!-- SECCIÓN 1: Identificación y Costos -->
            <div class="mb-4">
              <div class="d-flex align-center mb-3">
                <v-icon small color="primary" class="mr-2"
                  >mdi-identifier</v-icon
                >
                <span class="text-subtitle-1 font-weight-bold text--primary"
                  >Identificación y Costos</span
                >
              </div>

              <v-row dense>
                <!-- N° serie -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    label="N° serie *"
                    v-model="Item.num_serie"
                    outlined
                    dense
                    prepend-inner-icon="mdi-barcode"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Número de serie es requerido']"
                    required
                  ></v-text-field>
                </v-col>

                <!-- DOT -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    label="DOT *"
                    v-model="Item.dot"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar-clock"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'DOT es requerido']"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Costo sin IGV -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    label="Costo sin IGV *"
                    v-model="Item.precio"
                    outlined
                    dense
                    type="number"
                    prepend-inner-icon="mdi-cash"
                    hide-details="auto"
                    :rules="[
                      (v) =>
                        (v !== null && v !== undefined && v !== '') ||
                        'Costo sin IGV es requerido',
                    ]"
                    required
                  ></v-text-field>
                </v-col>

                <!-- Tipo moneda -->
                <v-col cols="12" sm="6" md="3">
                  <v-autocomplete
                    :items="tipoMoneda"
                    v-model="Item.tipo_moneda"
                    label="Seleccionar tipo moneda *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-currency-usd"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Tipo de moneda es requerido']"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- SECCIÓN 2: Características del Neumático -->
            <div class="mb-4">
              <div class="d-flex align-center mb-3">
                <v-icon small color="primary" class="mr-2">mdi-tire</v-icon>
                <span class="text-subtitle-1 font-weight-bold text--primary"
                  >Características del Neumático</span
                >
              </div>

              <v-row dense>
                <!-- Condición neumático -->
                <v-col cols="12" sm="6" md="3">
                  <v-autocomplete
                    :items="condicionNeumatico"
                    v-model="Item.nuevo"
                    label="Condición neumático *"
                    outlined
                    dense
                    prepend-inner-icon="mdi-tag-outline"
                    @change="onCondicion"
                    hide-details="auto"
                    :rules="[
                      (v) =>
                        (v !== null && v !== undefined) ||
                        'Condición es requerida',
                    ]"
                  ></v-autocomplete>
                </v-col>

                <!-- Campos si es Reencauchado (nuevo == 0) -->
                <template v-if="Item.nuevo == 0">
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      :items="cantidadesReencauche"
                      v-model="Item.cantidad_reencauche"
                      label="Cantidad de reencauches *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-numeric"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Cantidad es requerida']"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <div class="d-flex align-center">
                      <v-autocomplete
                        :items="Disenios"
                        v-model="Item.id_disenio"
                        label="Diseño de Banda *"
                        outlined
                        dense
                        prepend-inner-icon="mdi-texture-box"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'Diseño es requerido']"
                        class="mr-2"
                      ></v-autocomplete>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            height="38"
                            width="38"
                            class="elevation-1 flex-shrink-0"
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openModalDisennio()"
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Nuevo diseño</span>
                      </v-tooltip>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <div class="d-flex align-center">
                      <v-autocomplete
                        :items="Empresas"
                        v-model="Item.id_empresa"
                        label="Empresa Reencauchadora *"
                        outlined
                        dense
                        prepend-inner-icon="mdi-domain"
                        hide-details="auto"
                        :rules="[(v) => !!v || 'Empresa es requerida']"
                        class="mr-2"
                      ></v-autocomplete>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            height="38"
                            width="38"
                            class="elevation-1 flex-shrink-0"
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="openModalEmpresa()"
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Nueva empresa</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </template>

                <!-- Marca -->
                <v-col cols="12" sm="6" md="3">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      :items="Marcas"
                      v-model="Item.id_marca"
                      label="Marca *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-watermark"
                      @change="cargarModelos(Item.id_marca)"
                      :rules="[(v) => !!v || 'Marca es requerida']"
                      hide-details="auto"
                      class="mr-2"
                    ></v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          height="38"
                          width="38"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openModalMarca()"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Nueva marca</span>
                    </v-tooltip>
                  </div>
                </v-col>

                <!-- Modelo -->
                <v-col cols="12" sm="6" md="3">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      :items="modeloNeumaticoPorMarcaList"
                      v-model="Item.id_modelo"
                      label="Modelo *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-car-tire-alert"
                      :rules="[(v) => !!v || 'Modelo es requerido']"
                      hide-details="auto"
                      class="mr-2"
                    ></v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          height="38"
                          width="38"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openModalModelo()"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Nuevo modelo</span>
                    </v-tooltip>
                  </div>
                </v-col>

                <!-- Medida -->
                <v-col cols="12" sm="6" md="3">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      :items="Medidas"
                      v-model="Item.id_medida"
                      label="Medida *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-ruler-square-compass"
                      :rules="[(v) => !!v || 'Medida es requerida']"
                      hide-details="auto"
                      class="mr-2"
                    ></v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          height="38"
                          width="38"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openModalMedida()"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Nueva medida</span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- SECCIÓN 3: Profundidades, Kilometraje y Retiro -->
            <div class="mb-4">
              <div class="d-flex align-center mb-3">
                <v-icon small color="primary" class="mr-2"
                  >mdi-speedometer</v-icon
                >
                <span class="text-subtitle-1 font-weight-bold text--primary"
                  >Profundidades, Kilometraje y Scrap</span
                >
              </div>

              <v-row dense>
                <!-- Remanente original -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    type="number"
                    label="Remanente original *"
                    v-model="Item.remanente_original"
                    outlined
                    dense
                    suffix="mm"
                    prepend-inner-icon="mdi-ruler"
                    hide-details="auto"
                    :rules="profundidadRemanenteOriginal"
                    placeholder="00.00"
                    step="0.1"
                    min="0"
                  ></v-text-field>
                </v-col>

                <!-- Remanente final -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    type="number"
                    label="Remanente final"
                    v-model="Item.remanente_final"
                    outlined
                    dense
                    suffix="mm"
                    prepend-inner-icon="mdi-ruler"
                    hide-details="auto"
                    placeholder="00.00"
                    step="0.1"
                    min="0"
                  ></v-text-field>
                </v-col>

                <!-- Remanente límite -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    type="number"
                    label="Remanente límite *"
                    v-model="Item.remanente_limite"
                    outlined
                    dense
                    suffix="mm"
                    prepend-inner-icon="mdi-ruler-square"
                    hide-details="auto"
                    :rules="validarRemanenteLimite"
                    placeholder="00.00"
                    step="0.1"
                    min="0"
                  ></v-text-field>
                </v-col>

                <!-- Fecha RETIRO/SCRAP -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    type="date"
                    label="Fecha RETIRO/SCRAP *"
                    v-model="Item.fecha_scrap"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Fecha de scrap es requerida']"
                  ></v-text-field>
                </v-col>

                <!-- Kilómetro inicial -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    type="number"
                    label="Kilómetro inicial"
                    v-model="Item.km_inicial"
                    outlined
                    dense
                    suffix="km"
                    prepend-inner-icon="mdi-speedometer"
                    hide-details="auto"
                    min="0"
                  ></v-text-field>
                </v-col>

                <!-- Kilómetro final -->
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    type="number"
                    label="Kilómetro final"
                    v-model="Item.km_final"
                    outlined
                    dense
                    suffix="km"
                    prepend-inner-icon="mdi-speedometer"
                    hide-details="auto"
                    min="0"
                  ></v-text-field>
                </v-col>

                <!-- Motivo SCRAP -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center">
                    <v-autocomplete
                      :items="MotivosScrap"
                      v-model="Item.id_motivo_scrap"
                      label="Motivo SCRAP *"
                      outlined
                      dense
                      prepend-inner-icon="mdi-alert-octagon-outline"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'Motivo de scrap es requerido']"
                      class="mr-2"
                    ></v-autocomplete>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          height="38"
                          width="38"
                          class="elevation-1 flex-shrink-0"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openModalMotivoScrap()"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Nuevo motivo scrap</span>
                    </v-tooltip>
                  </div>
                </v-col>

                <!-- Recomendación -->
                <v-col cols="12" class="mt-2">
                  <v-textarea
                    label="Recomendación"
                    v-model="Item.recomendacion"
                    outlined
                    dense
                    rows="3"
                    auto-grow
                    counter="500"
                    maxlength="500"
                    clearable
                    prepend-inner-icon="mdi-comment-text-outline"
                    placeholder="Ingrese recomendaciones u observaciones técnicas sobre este neumático..."
                    hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- SECCIÓN 4: Evidencias Fotográficas (3 Imágenes) -->
            <div>
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-camera-burst</v-icon
                  >
                  <span class="text-subtitle-1 font-weight-bold text--primary"
                    >Evidencias Fotográficas</span
                  >
                </div>
                <span
                  class="text-caption grey--text text--darken-1 font-weight-medium"
                >
                  Seleccione las imágenes; se subirán al presionar Guardar
                </span>
              </div>

              <v-row dense>
                <!-- IMAGEN 1 -->
                <v-col cols="12" sm="6" md="4">
                  <v-card
                    outlined
                    class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
                  >
                    <div class="d-flex align-center justify-space-between mb-2">
                      <div class="d-flex align-center">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-camera</v-icon
                        >
                        <span class="font-weight-bold text-caption"
                          >IMAGEN 1</span
                        >
                      </div>
                      <v-chip
                        x-small
                        :color="previewLocal1 ? 'info' : 'grey lighten-2'"
                        :text-color="previewLocal1 ? 'white' : 'grey darken-2'"
                      >
                        {{ previewLocal1 ? "Por guardar" : "Sin imagen" }}
                      </v-chip>
                    </div>

                    <FileAgent
                      ref="fileAgent1"
                      :autoUpload="false"
                      @archivosubido="archivosubido1"
                      style="z-index: 0"
                    />

                    <div
                      class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                    >
                      <template v-if="previewLocal1">
                        <img
                          :src="previewLocal1"
                          alt="Nueva Foto 1"
                          class="preview-img"
                        />
                      </template>
                      <div v-else class="empty-state">
                        <v-icon large color="grey lighten-1"
                          >mdi-image-off-outline</v-icon
                        >
                        <span
                          class="text-caption grey--text text--darken-1 mt-1"
                          >Imagen no disponible</span
                        >
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <!-- IMAGEN 2 -->
                <v-col cols="12" sm="6" md="4">
                  <v-card
                    outlined
                    class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
                  >
                    <div class="d-flex align-center justify-space-between mb-2">
                      <div class="d-flex align-center">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-camera</v-icon
                        >
                        <span class="font-weight-bold text-caption"
                          >IMAGEN 2</span
                        >
                      </div>
                      <v-chip
                        x-small
                        :color="previewLocal2 ? 'info' : 'grey lighten-2'"
                        :text-color="previewLocal2 ? 'white' : 'grey darken-2'"
                      >
                        {{ previewLocal2 ? "Por guardar" : "Sin imagen" }}
                      </v-chip>
                    </div>

                    <FileAgent
                      ref="fileAgent2"
                      :autoUpload="false"
                      @archivosubido="archivosubido2"
                      style="z-index: 0"
                    />

                    <div
                      class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                    >
                      <template v-if="previewLocal2">
                        <img
                          :src="previewLocal2"
                          alt="Nueva Foto 2"
                          class="preview-img"
                        />
                      </template>
                      <div v-else class="empty-state">
                        <v-icon large color="grey lighten-1"
                          >mdi-image-off-outline</v-icon
                        >
                        <span
                          class="text-caption grey--text text--darken-1 mt-1"
                          >Imagen no disponible</span
                        >
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <!-- IMAGEN 3 -->
                <v-col cols="12" sm="6" md="4">
                  <v-card
                    outlined
                    class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
                  >
                    <div class="d-flex align-center justify-space-between mb-2">
                      <div class="d-flex align-center">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-camera</v-icon
                        >
                        <span class="font-weight-bold text-caption"
                          >IMAGEN 3</span
                        >
                      </div>
                      <v-chip
                        x-small
                        :color="previewLocal3 ? 'info' : 'grey lighten-2'"
                        :text-color="previewLocal3 ? 'white' : 'grey darken-2'"
                      >
                        {{ previewLocal3 ? "Por guardar" : "Sin imagen" }}
                      </v-chip>
                    </div>

                    <FileAgent
                      ref="fileAgent3"
                      :autoUpload="false"
                      @archivosubido="archivosubido3"
                      style="z-index: 0"
                    />

                    <div
                      class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                    >
                      <template v-if="previewLocal3">
                        <img
                          :src="previewLocal3"
                          alt="Nueva Foto 3"
                          class="preview-img"
                        />
                      </template>
                      <div v-else class="empty-state">
                        <v-icon large color="grey lighten-1"
                          >mdi-image-off-outline</v-icon
                        >
                        <span
                          class="text-caption grey--text text--darken-1 mt-1"
                          >Imagen no disponible</span
                        >
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <v-row justify="center" v-if="loader == true" class="mt-4">
              <vue-loaders name="ball-beat" color="red" scale="1"></vue-loaders>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Footer Actions -->
          <v-card-actions class="pa-4 bg-actions">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-2" @click="cerrarDialogo()">
              Cerrar
            </v-btn>
            <v-btn
              :disabled="!valid_form || loader || guardando"
              :loading="loader || guardando"
              color="info"
              class="px-6 font-weight-bold elevation-1 text-capitalize"
              @click="agregar()"
            >
              <v-icon left small>mdi-content-save</v-icon>
              {{ Item.id == null ? "Guardar" : "Actualizar" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!--MODAL ADD MARCA-->
    <v-dialog
      v-model="dialogMarca"
      max-width="300px"
      @click:outside="cerrarDialogMarca"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-form ref="form_marca" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre de la marca *"
                    required
                    v-model="marca.descripcion"
                    :rules="descripcionRules"
                  ></v-text-field>
                </v-col>
                <small v-if="mostrarLabelDuplicado" style="width: 100%">
                  <v-alert
                    outlined
                    style="
                      width: 100%;
                      background-color: rgba(244, 67, 54, 0.1) !important;
                      color: red !important;
                      border: 1px solid #dd8282 !important;
                    "
                    tonal
                    class="alert-chiquito w-100"
                    dense
                    type="error"
                  >
                    Marca Duplicada
                  </v-alert>
                </small>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="mostrarLabelDuplicado == false"
            >*Indicador de campo requerido</small
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            class="mt-4"
            style="width: 100%"
            small
            color="#009688"
            @click="addMarca(marca)"
          >
            <font color="white">Agregar</font>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MODELO-->
    <v-dialog
      v-model="dialogModelo"
      max-width="300px"
      @click:outside="cerrarDialogModelo"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-form ref="form_modelo" v-model="valid">
              <v-row>
                <v-col cols="12" class="mt-5">
                  <v-autocomplete
                    :items="Marcas"
                    v-model="modelo.id_marca"
                    label="Marca de neumático"
                    :rules="[(v) => !!v || 'Marca es requerido']"
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre del modelo *"
                    placeholder="HN08"
                    required
                    v-model="modelo.descripcion"
                    :rules="descripcionRules"
                  ></v-text-field>
                </v-col>
                <small v-if="mostrarLabelDuplicado" style="width: 100%">
                  <v-alert
                    outlined
                    style="
                      width: 100%;
                      background-color: rgba(244, 67, 54, 0.1) !important;
                      color: red !important;
                      border: 1px solid #dd8282 !important;
                    "
                    tonal
                    class="alert-chiquito w-100"
                    dense
                    type="error"
                  >
                    Modelo Duplicado
                  </v-alert>
                </small>
              </v-row>
            </v-form>
          </v-container>
          <small>*Indicador de campo requerido</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            style="width: 100%"
            small
            color="#009688"
            @click="addModelo(modelo)"
          >
            <font color="white">Agregar</font>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MEDIDA-->
    <v-row justify="center" v-if="modal_form_medida">
      <v-dialog
        v-model="dialogMedida"
        max-width="450px"
        @click:outside="cerrarDialogMedida"
      >
        <v-card>
          <v-card-text>
            <v-container>
              <v-form ref="form_medida" v-model="valid">
                <v-row>
                  <v-col cols="12" md="4" sm="4">
                    <v-text-field
                      hint="275"
                      persistent-hint
                      label="Ancho de la llanta *"
                      @change="onEscribirDescripcion"
                      v-model="medida.ancho"
                      :rules="[(v) => !!v || 'Ancho es requerido']"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <v-text-field
                      hint="70"
                      persistent-hint
                      label="Perfil de la llanta *"
                      @change="onEscribirDescripcion"
                      v-model="medida.perfil"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" sm="4">
                    <v-text-field
                      hint="22.5"
                      persistent-hint
                      label="Aro de la llanta *"
                      @change="onEscribirDescripcion"
                      v-model="medida.aro"
                      :rules="[(v) => !!v || 'Aro es requerido']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      hint="275/70R22.5"
                      :readonly="!checkbox"
                      persistent-hint
                      label="Medida/Descripción *"
                      v-model="medida.descripcion"
                      :rules="descripcionRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="pa-0">
                    <v-checkbox
                      v-model="checkbox"
                      label="Activar descripción"
                    ></v-checkbox>
                  </v-col>
                  <small v-if="mostrarLabelDuplicado" style="width: 100%">
                    <v-alert
                      outlined
                      style="
                        width: 100%;
                        background-color: rgba(244, 67, 54, 0.1) !important;
                        color: red !important;
                        border: 1px solid #dd8282 !important;
                      "
                      tonal
                      class="alert-chiquito w-100"
                      dense
                      type="error"
                    >
                      Medida Duplicada
                    </v-alert>
                  </small>
                </v-row>
              </v-form>
            </v-container>
            <small>*Indicador de campo requerido</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid"
              style="width: 100%"
              small
              color="#009688"
              @click="addMedida(medida)"
            >
              <font color="white">Agregar</font>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--MODAL ADD DISENIO-->
    <v-dialog
      v-model="dialogDisenio"
      max-width="300px"
      @click:outside="cerrarDialogDisenio"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-form ref="form_disenio" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Diseño *"
                    required
                    v-model="disenio.nombre"
                    :rules="descripcionRules"
                  ></v-text-field>
                </v-col>
                <small v-if="mostrarLabelDuplicado" style="width: 100%">
                  <v-alert
                    outlined
                    style="
                      width: 100%;
                      background-color: rgba(244, 67, 54, 0.1) !important;
                      color: red !important;
                      border: 1px solid #dd8282 !important;
                    "
                    tonal
                    class="alert-chiquito w-100"
                    dense
                    type="error"
                  >
                    Diseño Duplicado
                  </v-alert>
                </small>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="mostrarLabelDuplicado == false"
            >*Indicador de campo requerido</small
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            class="mt-4"
            style="width: 100%"
            small
            color="#009688"
            @click="addDisenio(disenio)"
          >
            <font color="white">Agregar</font>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--MODAL ADD EMPRESA-->
    <v-dialog
      v-model="dialogEmpresa"
      max-width="300px"
      @click:outside="cerrarDialogEmpresa"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-form ref="form_empresa" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="RUC *"
                    required
                    v-model="empresa.ruc"
                    :rules="descripcionRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Razon social *"
                    required
                    v-model="empresa.razon_social"
                    :rules="descripcionRules"
                  ></v-text-field>
                </v-col>
                <small v-if="mostrarLabelDuplicado" style="width: 100%">
                  <v-alert
                    outlined
                    style="
                      width: 100%;
                      background-color: rgba(244, 67, 54, 0.1) !important;
                      color: red !important;
                      border: 1px solid #dd8282 !important;
                    "
                    tonal
                    class="alert-chiquito w-100"
                    dense
                    type="error"
                  >
                    RUC Duplicado
                  </v-alert>
                </small>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="mostrarLabelDuplicado == false"
            >*Indicador de campo requerido</small
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            class="mt-4"
            style="width: 100%"
            small
            color="#009688"
            @click="addEmpresa(empresa)"
          >
            <font color="white">Agregar</font>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--MODAL ADD MOTIVO SCRAP-->
    <v-dialog
      v-model="dialogMotivoScrap"
      max-width="500px"
      @click:outside="cerrarDialogMotivoScrap"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-form ref="form_motivoscrap" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre del Motivo Scrap *"
                    required
                    v-model="motivoscrap.motivo"
                    :rules="descripcionRules"
                  ></v-text-field>
                </v-col>
                <small v-if="mostrarLabelDuplicado" style="width: 100%">
                  <v-alert
                    outlined
                    style="
                      width: 100%;
                      background-color: rgba(244, 67, 54, 0.1) !important;
                      color: red !important;
                      border: 1px solid #dd8282 !important;
                    "
                    tonal
                    class="alert-chiquito w-100"
                    dense
                    type="error"
                  >
                    Motivo Duplicado
                  </v-alert>
                </small>
              </v-row>
            </v-form>
          </v-container>
          <small v-if="mostrarLabelDuplicado == false"
            >*Indicador de campo requerido</small
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            class="mt-4"
            style="width: 100%"
            small
            color="#009688"
            @click="addMotivoScrap(motivoscrap)"
          >
            <font color="white">Agregar</font>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FileAgent from "../FileAgent.vue";
// import axios from "axios";
import { axios2 as axios } from "@/interceptor/useApi";
import global from "../../global";
import { notif } from "@/plugins/notyf";

export default {
  props: [
    "dialog",
    "Marcas",
    "Modelos",
    "Medidas",
    "Disenios",
    "MotivosScrap",
    "Empresas",
  ],
  components: {
    FileAgent,
  },
  data() {
    return {
      Item: {},
      tipoMoneda: [
        {
          value: 2,
          text: "$ Dólares",
        },
        {
          value: 1,
          text: "S/. Soles",
        },
      ],
      condicionNeumatico: [
        {
          value: 1,
          text: "Nuevo",
        },
        {
          value: 0,
          text: "Reencauchado",
        },
      ],
      cantidadesReencauche: [
        {
          value: 1,
          text: 1,
        },
        {
          value: 2,
          text: 2,
        },
        {
          value: 3,
          text: 3,
        },
        {
          value: 4,
          text: 4,
        },
        {
          value: 5,
          text: 5,
        },
        {
          value: 6,
          text: 6,
        },
      ],
      checkbox: false,
      loader: false,
      valid_form: true,
      modal_scrap: true,
      valid: false,
      dialogMarca: false,
      dialogModelo: false,
      dialogMedida: false,
      dialogMotivoScrap: false,
      dialogDisenio: false,
      dialogEmpresa: false,
      mostrarLabelDuplicado: false,
      marca: {},
      modelo: {},
      medida: {},
      disenio: {},
      motivoscrap: {},
      empresa: {},
      profundidadRemanenteOriginal: [
        (v) => !!v || "Profundidad es requerida",
        (v) => (v && v <= 999) || "Profundidad debe ser menor a 3 caracteres",
      ],
      profundidadRemanenteFinal: [
        (v) => !!v || "Profundidad es requerida",
        (v) => (v && v <= 999) || "Profundidad debe ser menor a 3 caracteres",
      ],
      validarRemanenteLimite: [
        (v) => !!v || "Profundidad es requerida",
        (v) => (v && v <= 999) || "Profundidad debe ser menor a 3 caracteres",
      ],
      //validarRemanenteOriginal: this.profundidadRemanenteOriginal,
      //validarRemanenteFinal: this.profundidadRemanenteFinal,
      descripcionRules: [(v) => !!v || "Descripción es requerido"],
      modal_form_medida: false,
      modal_form_motivoscrap: false,
      modeloNeumaticoPorMarcaList: [],
      guardando: false,
      nuevaFoto1: null,
      nuevaFoto2: null,
      nuevaFoto3: null,
      previewLocal1: null,
      previewLocal2: null,
      previewLocal3: null,
    };
  },
  methods: {
    ...mapActions("neumatico", ["agregarItemArray"]),
    ...mapActions("motivosscrap", ["agregarMotivosScrap"]),

    limpiarArchivosLocales() {
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      if (this.previewLocal2) URL.revokeObjectURL(this.previewLocal2);
      if (this.previewLocal3) URL.revokeObjectURL(this.previewLocal3);
      this.nuevaFoto1 = null;
      this.nuevaFoto2 = null;
      this.nuevaFoto3 = null;
      this.previewLocal1 = null;
      this.previewLocal2 = null;
      this.previewLocal3 = null;
      if (this.$refs.fileAgent1) this.$refs.fileAgent1.reset();
      if (this.$refs.fileAgent2) this.$refs.fileAgent2.reset();
      if (this.$refs.fileAgent3) this.$refs.fileAgent3.reset();
    },

    archivosubido1: function ({ valor, fileRecords }) {
      this.nuevaFoto1 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      if (this.nuevaFoto1 && this.nuevaFoto1[0] && this.nuevaFoto1[0].file) {
        this.previewLocal1 = URL.createObjectURL(this.nuevaFoto1[0].file);
      } else {
        this.previewLocal1 = null;
      }
    },

    archivosubido2: function ({ valor, fileRecords }) {
      this.nuevaFoto2 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal2) URL.revokeObjectURL(this.previewLocal2);
      if (this.nuevaFoto2 && this.nuevaFoto2[0] && this.nuevaFoto2[0].file) {
        this.previewLocal2 = URL.createObjectURL(this.nuevaFoto2[0].file);
      } else {
        this.previewLocal2 = null;
      }
    },

    archivosubido3: function ({ valor, fileRecords }) {
      this.nuevaFoto3 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal3) URL.revokeObjectURL(this.previewLocal3);
      if (this.nuevaFoto3 && this.nuevaFoto3[0] && this.nuevaFoto3[0].file) {
        this.previewLocal3 = URL.createObjectURL(this.nuevaFoto3[0].file);
      } else {
        this.previewLocal3 = null;
      }
    },

    onCondicion: function () {
      this.Item.id_disenio = null;
      this.Item.cantidad_reencauche = null;
      this.Item.id_empresa = null;
      /*
            if (this.Item.nuevo == 1) {
                this.validarRemanenteOriginal = this.profundidadRemanenteOriginal;
                this.validarRemanenteActual = [];
            } else {
                this.validarRemanenteFinal = this.profundidadRemanenteFinal;
                this.validarRemanenteFinal = [];
            }
            */
    },
    onEscribirDescripcion() {
      if (this.medida.ancho == "") {
        this.medida.descripcion = this.medida.perfil + "R" + this.medida.aro;
      } else if (this.medida.perfil == "" && this.medida.aro == "") {
        this.medida.descripcion = this.medida.ancho;
      } else if (this.medida.perfil != "" && this.medida.aro == "") {
        this.medida.descripcion = this.medida.ancho + "/" + this.medida.perfil;
      } else if (
        this.medida.ancho != "" &&
        this.medida.aro != "" &&
        this.medida.perfil == ""
      ) {
        this.medida.descripcion = this.medida.ancho + "R" + this.medida.aro;
      } else {
        this.medida.descripcion =
          this.medida.ancho + "/" + this.medida.perfil + "R" + this.medida.aro;
      }
    },

    inicializarMarca: function () {
      this.marca = {
        descripcion: null,
      };
    },

    inicializarModelo: function () {
      this.modelo = {
        id_medida: null,
        descripcion: null,
      };
    },

    inicializarMedida: function () {
      this.medida = {
        descripcion: null,
        ancho: "",
        perfil: "",
        aro: "",
      };
    },

    inicializarEmpresa: function () {
      this.empresa = {
        razon_social: null,
      };
    },

    inicializarDisenio: function () {
      this.disenio = {
        nombre: null,
      };
    },

    inicializarMotivoScrap: function () {
      this.motivoscrap = {
        motivo: null,
      };
    },

    cargarModelos: function (id_marca) {
      this.modeloNeumaticoPorMarcaList = [];
      this.Modelos.forEach((element) => {
        if (element.marca == id_marca) {
          this.modeloNeumaticoPorMarcaList.push(element);
        }
      });
    },

    openModalMarca: function () {
      this.mostrarLabelDuplicado = false;
      this.$nextTick().then(() => {
        this.modal_form_marca = true;
      });
      this.inicializarMarca();
      if (this.Item.id_marca != null) {
        this.marca.id_marca = this.Item.id_marca;
      }
      this.dialogMarca = true;
    },

    openModalModelo: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarModelo();
      if (this.Item.id_marca != null) {
        this.modelo.id_marca = this.Item.id_marca;
      }
      this.dialogModelo = true;
    },

    openModalMedida: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarMedida();
      this.$nextTick().then(() => {
        this.modal_form_medida = true;
      });
      this.dialogMedida = true;
    },

    openModalMotivoScrap: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarMotivoScrap();
      this.$nextTick().then(() => {
        this.modal_form_motivoscrap = true;
      });
      this.dialogMotivoScrap = true;
    },

    openModalDisennio: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarDisenio();
      this.dialogDisenio = true;
    },

    openModalEmpresa: function () {
      this.mostrarLabelDuplicado = false;
      this.inicializarEmpresa();
      this.dialogEmpresa = true;
    },

    addMotivoScrap: async function (item) {
      if (
        !global.verificarDuplicados(
          this.MotivosScrap,
          item.motivo.toUpperCase(),
        )
      ) {
        //Guardar en la base de datos
        let dato = await this.agregarMotivosScrap({
          url: "motivos/scrap",
          motivo: item.motivo.toUpperCase(),
        });
        this.MotivosScrap.push({
          value: dato.id,
          text: dato.motivo,
        });
        console.log(dato, "dato", this.MotivosScrap);
        this.dialogMotivoScrap = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addMarca: async function (item) {
      if (
        !global.verificarDuplicados(this.Marcas, item.descripcion.toUpperCase())
      ) {
        //Guardar en la base de datos
        item.descripcion = item.descripcion.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticomarca/store",
          item: item,
        });
        this.Marcas.push({
          value: dato.id,
          text: dato.descripcion,
        });
        this.dialogMarca = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addModelo: async function (item) {
      console.log(item);
      var modeloNeumaticoPorMarcaList1 = [];
      this.Modelos.forEach((element) => {
        if (element.marca == item.id_marca) {
          modeloNeumaticoPorMarcaList1.push(element);
        }
      });
      if (
        !global.verificarDuplicados(
          modeloNeumaticoPorMarcaList1,
          item.descripcion.toUpperCase(),
        )
      ) {
        item.descripcion = item.descripcion.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticomodelo/store",
          item: item,
        });
        this.Modelos.push({
          value: dato.id,
          text: dato.descripcion,
          marca: dato.marca,
        });
        this.modeloNeumaticoPorMarcaList = [];
        if (this.Item.id_marca != null) {
          this.cargarModelos(this.Item.id_marca);
        }
        this.dialogModelo = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addMedida: async function (item) {
      if (
        !global.verificarDuplicados(
          this.Medidas,
          item.descripcion.toUpperCase(),
        )
      ) {
        //Guardar en la base de datos
        item.descripcion = item.descripcion.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticomedida/store",
          item: item,
        });
        this.Medidas.push({
          value: dato.id,
          text: dato.descripcion,
        });
        this.dialogMedida = false;
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addDisenio: async function (item) {
      if (
        !global.verificarDuplicados(this.Disenios, item.nombre.toUpperCase())
      ) {
        //Guardar en la base de datos
        item.nombre = item.nombre.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "neumaticodisenio/store",
          item: item,
        });
        this.Disenios.push({
          value: dato.id,
          text: dato.nombre,
        });
        this.dialogDisenio = false; //Dialog
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    addEmpresa: async function (item) {
      let existe = false;
      this.Empresas.forEach((element) => {
        if (element.ruc == item.ruc) {
          existe = true;
        }
      });
      if (!existe) {
        //Guardar en la base de datos
        item.razon_social = item.razon_social.toUpperCase();
        let dato = await this.agregarItemArray({
          url: "empresas/store",
          item: item,
        });
        this.Empresas.push({
          value: dato.id,
          text: dato.razon_social,
        });
        this.dialogEmpresa = false; //Dialog
      } else {
        this.mostrarLabelDuplicado = true;
      }
    },

    cerrarDialogo() {
      this.limpiarArchivosLocales();
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.$emit("dialog", false);
    },

    cerrarDialogMarca() {
      this.dialogMarca = false;
      this.$refs.form_marca.reset();
    },

    cerrarDialogModelo() {
      this.dialogModelo = false;
      this.$refs.form_modelo.reset();
    },

    cerrarDialogMedida() {
      this.dialogMedida = false;
      this.modal_form_medida = false;
      this.$refs.form_medida.reset();
    },

    cerrarDialogMotivoScrap() {
      this.dialogMotivoScrap = false;
      this.modal_form_motivoscrap = false;
      this.$refs.form_motivoscrap.reset();
    },

    cerrarDialogDisenio() {
      this.dialogDisenio = false;
      this.$refs.form_disenio.reset();
    },

    cerrarDialogEmpresa() {
      this.dialogEmpresa = false;
      this.$refs.form_empresa.reset();
    },

    async subirFoto(file) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("imagen/subirimagen", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return typeof res.data === "string"
        ? res.data
        : res.data?.data || res.data?.nombre || "";
    },

    async agregar() {
      try {
        if (this.Item.km_inicial == null || this.Item.km_inicial === "") {
          this.Item.km_inicial = 0;
        }
        if (
          this.Item.remanente_final == null ||
          this.Item.remanente_final === ""
        ) {
          this.Item.remanente_final = 0;
        }
        if (this.$refs.form.validate()) {
          this.loader = true;
          this.guardando = true;

          // 1. Subir Foto 1 si hay archivo seleccionado
          if (
            this.nuevaFoto1 &&
            this.nuevaFoto1.length > 0 &&
            this.nuevaFoto1[0].file
          ) {
            const nombre1 = await this.subirFoto(this.nuevaFoto1[0].file);
            if (nombre1) {
              this.Item.ruta1 = [{ upload: { data: nombre1 } }];
              this.Item.neumaticoimg1 = nombre1;
              this.Item.neumaticoimgruta1 =
                "images/reportes/img_neumaticos_mal_estado/" + nombre1;
            }
          }

          // 2. Subir Foto 2 si hay archivo seleccionado
          if (
            this.nuevaFoto2 &&
            this.nuevaFoto2.length > 0 &&
            this.nuevaFoto2[0].file
          ) {
            const nombre2 = await this.subirFoto(this.nuevaFoto2[0].file);
            if (nombre2) {
              this.Item.ruta2 = [{ upload: { data: nombre2 } }];
              this.Item.neumaticoimg2 = nombre2;
              this.Item.neumaticoimgruta2 =
                "images/reportes/img_neumaticos_mal_estado/" + nombre2;
            }
          }

          // 3. Subir Foto 3 si hay archivo seleccionado
          if (
            this.nuevaFoto3 &&
            this.nuevaFoto3.length > 0 &&
            this.nuevaFoto3[0].file
          ) {
            const nombre3 = await this.subirFoto(this.nuevaFoto3[0].file);
            if (nombre3) {
              this.Item.ruta3 = [{ upload: { data: nombre3 } }];
              this.Item.neumaticoimg3 = nombre3;
              this.Item.neumaticoimgruta3 =
                "images/reportes/img_neumaticos_mal_estado/" + nombre3;
            }
          }

          const url = "neumaticos/storescrap";
          const data = {
            id_cliente: localStorage.getItem("idcliente"),
            id_usuario: localStorage.getItem("id"),
            neumatico: this.Item,
          };
          const response = await axios.post(url, data);
          if (response?.status == 200) {
            notif.success("Operación realizada con éxito");
            this.limpiarArchivosLocales();
            this.cerrarDialogo();
            this.$emit("cargarNeumaticosScrap");
          }
        }
      } catch (error) {
        console.error("error!", error);
        const msg =
          error.response?.data?.message || "Error al registrar en scrap";
        notif.error(msg);
      } finally {
        this.loader = false;
        this.guardando = false;
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.limpiarArchivosLocales();
        if (this.$refs.form) this.$refs.form.resetValidation();
      } else {
        this.Item = {};
      }
    },
  },
  beforeDestroy() {
    this.limpiarArchivosLocales();
  },
  mounted() {},
};
</script>
<style scoped>
.alert-chiquito {
  font-size: 12px;
  padding: 4px 8px;
  margin: 4px 0;
  background-color: rgba(244, 67, 54, 0.1) !important;
  color: #000 !important;
}
.alert-chiquito.v-alert__wrapper.v-icon {
  color: red !important;
}
.photo-card {
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  transition: all 0.2s ease-in-out;
}
.photo-card:hover {
  border-color: #94a3b8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.preview-box {
  min-height: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  overflow: hidden;
  padding: 6px;
}
.preview-img {
  width: 100%;
  max-height: 210px;
  object-fit: contain;
  border-radius: 6px;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
}
.bg-actions {
  background-color: #f8fafc;
}
</style>
